import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import MinisiteView from './MinisiteView';
import { useOccasionByKey, MINISITE_HUB_PATH } from '../utils/minisiteOccasions';
import { useT } from '../i18n';

// Exemple de faire-part animé (mariage) dans un cadre de téléphone, même présentation que la démo de
// carte à gratter (DemoScratchCardPage.js) : cible du bandeau DemoBanner.js. 100 % statique, sans
// base de données ; le formulaire de réponse est affiché mais n'envoie rien (mode embarqué).
// Les textes d'exemple (prénoms, programme, message) viennent de l'occasion « mariage » dans la langue courante.

const DemoMinisitePage = () => {
  const t = useT('demo');
  const mariage = useOccasionByKey('mariage'); // occasion « mariage » : textes d'exemple traduits, valeurs (date, lieu, style) inchangées
  const DEMO = useMemo(() => ({ occasion: 'mariage', ...mariage.demo, ...mariage.hub.demo }), [mariage]);
  const [replayKey, setReplayKey] = useState(0);

  return (
    <>
      <Helmet>
        <title>{`${t('demo.minisite.title')} | Joli Ptit Mot`}</title>
        <meta name="description" content={t('demo.minisite.description')} />
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <Box sx={{ maxWidth: 480, margin: '0 auto', textAlign: 'center', py: { xs: 3, md: 5 } }}>
        <Typography
          variant="h4"
          sx={{ mb: 1, color: '#c48f8b', fontFamily: "'Cormorant Garamond', Georgia, serif", fontWeight: 600 }}
        >
          {t('demo.tryHeading')}
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: '#7a6060' }}>
          {t('demo.minisite.intro')}
        </Typography>

        <div className="ms-phone" style={{ width: 340, height: 700 }}>
          <MinisiteView key={replayKey} embedded params={DEMO} />
        </div>
        <Button size="small" sx={{ mt: 1 }} onClick={() => setReplayKey((k) => k + 1)}>
          {t('demo.minisite.replay')}
        </Button>

        <Box>
          <Button
            component={Link}
            to={MINISITE_HUB_PATH}
            variant="contained"
            color="secondary"
            sx={{ mt: 3, borderRadius: 6, px: 4, py: 1.2, fontWeight: 700 }}
          >
            {t('demo.minisite.create')}
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default DemoMinisitePage;
